import React from 'react';
import { useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { T_TableRow, T_TitleCell } from '~/components/TableItem';

const RenderTableTitle = () => {
  const ary = [
    { name: '港口' },
    { name: '碼頭編號' },
    { name: '使用風場' },
  ];
  return (
    <TableHead>
      <TableRow style={{ height: 48 }}>
        {ary.map((o, i) => (
          <T_TitleCell
            key={i}
            text={o.name}
          />
        ))}
      </TableRow>
    </TableHead>
  );
};

const RenderTableBody = () => {
  const list = useSelector(state => state.data.GisWinds2 || []);
  const cellStyle = { fontSize: 14 };

  return (
    <TableBody>
      {list.map((o, i) => (
        <T_TableRow key={i}>
          <TableCell align='center' style={cellStyle}>{o.dock}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.dock_num}</TableCell>
          <TableCell align='center' style={cellStyle}>
            {o.windcontract_data?.windfield_simplename}
          </TableCell>
        </T_TableRow>
      ))}
    </TableBody>
  );
};

const RenderTable = () => {
  const list = useSelector(state => state.data.GisWinds2 || []);
  const haveData = list.length > 0;
  return (
    <TableContainer>
      <Table style={{ backgroundColor: 'white', borderRadius: 8, borderTopLeftRadius: 0, minWidth: 235 }}>
        <RenderTableTitle />
        {haveData && <RenderTableBody />}
      </Table>
    </TableContainer>
  );
};

const App = () => {
  const list = useSelector(state => state.data.GisWinds2 || []);
  const haveData = list.length > 0;
  return (
    <div style={{ width: 'calc(50% - 35px)' }}>
      <div style={{ display: 'flex' }}>
        <div style={ {
          backgroundColor: '#4CC2CA',
          height: 50,
          borderTopLeftRadius: 11,
          position: 'relative',
        }}
        >
          <div style={{ lineHeight: ' 50px', color: 'white', fontWeight: 700, fontSize: 20, marginLeft: 8, marginRight: 20 }}>運維碼頭</div>
          <div
            style={{
              backgroundColor: '#4CC2CA',
              height: 50,
              width: 40,
              clipPath: 'polygon(0% 100%, 0% 0%, 30% 0%, 100% 100%)',
              position: 'absolute',
              top: 0,
              left: ' calc(100% - 1px)',
            }}
          />
        </div>
      </div>
      <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)' }}>
        <RenderTable />
        {/* {haveData && this.renderTableBar()} */}
      </div>
      {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
    </div>
  );
};

export default App;
